// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"132":"18935a48","500":"f3c6577c","507":"18935a48"}[chunkId] + ".chunk.css");